import Lottie from 'lottie-react';
import { useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { PageTemplate } from '@_widgets/common';

import { SpeechBubbleIcon } from '@_shared/icons';
import { CHARACTER_IMGS, ONBOARDING_IMGS } from '@_shared/imgs';
import * as LottieJsonFiles from '@_shared/lottie';
import { Button } from '@_shared/ui/Button';
import { Typography } from '@_shared/ui/Typography';

import * as S from './SignupOnboardingPage.style.ts';

const SLIDE_IMG_HEIGHT = '388px';
const ONBOARDING_SLIDE_LENGTH = 5;

export function SignupOnboardingPage() {
	const navigate = useNavigate();
	const location = useLocation();

	const [idx, setIdx] = useState(0);
	const sliderRef = useRef<Slider>(null);

	const settings = {
		dots: true,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,

		draggable: false,
		swipe: false,
		arrows: false,
		afterChange: (current: number) => {
			setIdx(current);
		},
	};

	function isLastSlide() {
		return idx === ONBOARDING_SLIDE_LENGTH;
	}

	function isFirstSlide() {
		return idx === 0;
	}

	return (
		<PageTemplate
			header={false}
			nav={
				<S.BottomButtonContainer>
					{!isFirstSlide() && (
						<Button
							bgColor="white-primary"
							borderColor="orange-primary"
							fullWidth
							onClick={() => {
								sliderRef.current?.slickPrev();
							}}
						>
							<Typography type="title-large" color="orange-primary">
								이전
							</Typography>
						</Button>
					)}
					<Button
						bgColor="orange-primary"
						fullWidth
						onClick={() => {
							if (isLastSlide()) {
								navigate(`/signup${location.search}`);
							} else {
								sliderRef.current?.slickNext();
							}
						}}
					>
						<Typography type="title-large" color="white-primary">
							{isLastSlide() ? '시작하기' : '다음'}
						</Typography>
					</Button>
				</S.BottomButtonContainer>
			}
		>
			<S.SliderWrapper className="slider-container">
				<Slider {...settings} ref={sliderRef}>
					<S.TextSlide>
						<S.FirstSlideContainer>
							<SpeechBubbleIcon />
							<S.FirstSlideTitle>딸깍에 오신 것을 환영해요! ✨</S.FirstSlideTitle>
						</S.FirstSlideContainer>
						<img
							src={CHARACTER_IMGS.MAGNIFYING_GLASS_CHARACTER_GIF}
							alt="MAGNIFYING GLASS CHARACTER GIF"
						/>
						<Typography type="title-large" color="font-secondary" textAlign="center">
							앵심이가 사용법을 알려드릴게요
						</Typography>
					</S.TextSlide>

					<S.ImgSlide>
						<Typography type="headline-large" color="font-primary" textAlign="center">
							저장하고 싶은 콘텐츠를
							<br />
							공유해 보세요
						</Typography>

						<S.LottieWrapper>
							<Lottie animationData={LottieJsonFiles.onboarding2Lottie} />
						</S.LottieWrapper>
					</S.ImgSlide>

					<S.ImgSlide>
						<Typography type="headline-large" color="font-primary" textAlign="center">
							폴더를 선택하고
							<br />
							메모도 자유롭게 작성해요
						</Typography>

						<img
							src={ONBOARDING_IMGS.ONBOARDING_IMG3}
							alt="ONBOARDING IMG"
							style={{
								height: SLIDE_IMG_HEIGHT,
							}}
						/>
					</S.ImgSlide>

					<S.ImgSlide>
						<Typography type="headline-large" color="font-primary" textAlign="center">
							저장한 콘텐츠를
							<br />
							한눈에 확인해요
						</Typography>

						<img
							src={ONBOARDING_IMGS.ONBOARDING_IMG5}
							alt="ONBOARDING IMG"
							style={{
								height: SLIDE_IMG_HEIGHT,
							}}
						/>
					</S.ImgSlide>

					<S.ImgSlide>
						<div>
							<Typography
								type="title-medium"
								color="orange-primary"
								textAlign="center"
							>
								공유하기에서 딸깍이 안 보이시나요?
							</Typography>
							<Typography
								type="headline-large"
								color="font-primary"
								textAlign="center"
							>
								공유 즐겨찾기에
								<br />
								딸깍을 추가해 주세요!
							</Typography>
						</div>

						<S.LottieWrapper>
							<Lottie animationData={LottieJsonFiles.onboarding5Lottie} />
						</S.LottieWrapper>
					</S.ImgSlide>

					<S.TextSlide>
						<Typography type="headline-large" color="font-primary" textAlign="center">
							딸깍에 첫 콘텐츠를
							<br />
							담아볼까요?
						</Typography>

						<Typography type="title-medium" color="orange-primary" textAlign="center">
							저장하신 콘텐츠를 안전하게 보관할 수 있도록
							<br />
							딸깍 회원이 되어주세요 :)
						</Typography>
					</S.TextSlide>
				</Slider>
			</S.SliderWrapper>
		</PageTemplate>
	);
}
